module.exports = __webpack_public_path__ + "static/media/adobexd.c19bee3c.svg";